/**
 * Rodzaj konkursu
 *
 * @export
 * @enum {number}
 */
export enum ContestType {
  ARTISTIC = 1,
  KNOWLEDGE = 2
}

export const contestTypeTranslation = {
  [ContestType.ARTISTIC]: 'Artystyczny',
  [ContestType.KNOWLEDGE]: 'Wiedzowy'
};

export const contestTypeList = [
  { value: ContestType[1], text: contestTypeTranslation[ContestType.ARTISTIC] },
  { value: ContestType[2], text: contestTypeTranslation[ContestType.KNOWLEDGE] }
];
